module.exports = {"210423100":"清原镇","210423101":"红透山镇","210423103":"草市镇","210423104":"英额门镇","210423105":"南口前镇","210423106":"南山城镇","210423107":"湾甸子镇","210423108":"大孤家镇","210423109":"夏家堡镇","210423110":"北三家镇","210423203":"土口子乡","210423206":"敖家堡乡","210423207":"大苏河乡","210423208":"枸乃甸乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210423.json
// module id = 538
// module chunks = 0